import urlBuilder from "@Utils/urlBuilder";
import { logger } from "helpers/logger";
import config from "@Config/index";
import axios from "axios";
import { convertCompleteUrlToWhitelabelUrl } from "@Pages/WhitelabelHome/Desktop/helpers/WhiteLabelRedirectionHelper";

type fetchInventoryProps = {
  email: string;
  inventory_id: string;
  nationality?: string | null;
};

export const getPaymentSummaryLabel = (payment_type: string) => {
  switch (payment_type) {
    case "deposit":
      return "Deposit Payment";
    case "rent":
      return "Rent Instalment";
    case "refundable_token":
      return "Fully Refundable Holding Fee";
    case "platform_fee":
      return "Amber Service Fee";
    default:
      return "Deposit Payment";
  }
};

export const getPaymentCompleteUrlNew = (
  baseURL: string,
  params = {},
  whitelabelParams: {
    isWhitelabel?: boolean;
    isDemoSubdomain?: boolean;
    partner_uuid?: string;
  },
) => {
  const { isWhitelabel, isDemoSubdomain, partner_uuid } = whitelabelParams || {};
  const paths = [baseURL, "payments", "complete"];
  let final_url = urlBuilder(paths, { params });

  if (isWhitelabel && partner_uuid) {
    final_url = convertCompleteUrlToWhitelabelUrl(
      final_url,
      isDemoSubdomain || false,
      partner_uuid,
    );
  }
  return final_url;
};

export const getFailedCustomPaymentFullUrl = (
  baseURL: string,
  params: any = { token: "" },
  whitelabelParams: {
    isWhitelabel?: boolean;
    isDemoSubdomain?: boolean;
    partner_uuid?: string;
  },
) => {
  const { isWhitelabel, isDemoSubdomain, partner_uuid } = whitelabelParams || {};
  const paths = [baseURL, "payments", params.token];
  let final_url = urlBuilder(paths, { params });

  if (isWhitelabel && partner_uuid) {
    final_url = convertCompleteUrlToWhitelabelUrl(
      final_url,
      isDemoSubdomain || false,
      partner_uuid,
    );
  }

  return final_url;
};

export const getFailedPaymentFullUrl = (
  baseURL: string,
  inventory: { canonical_name: string },
  params = {},
) => {
  const { canonical_name } = inventory;
  const paths = [baseURL, "/places", canonical_name, "payment"];
  // Build link
  return urlBuilder(paths, { params });
};

export const getParsedSessionStorageData = (key: string) => {
  if (typeof sessionStorage !== "undefined") {
    let data = sessionStorage.getItem(key);
    if (data) {
      // Parse it to a javaScript object
      try {
        data = JSON.parse(data);
      } catch (err) {
        // @ts-ignore
        logger.log(err);
      }
      return data;
    }
  }
  return null;
};

export const setSessionStorageData = (key: string, data: any) => {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem(key, data);
  }
};

export const fetchNationalityBasedPaymentDetails = async ({
  email,
  inventory_id,
  nationality = null,
}: fetchInventoryProps) => {
  const params: Record<string, any> = {
    email,
    inventory_id,
    cache: false,
  };

  if (nationality) params["nationality"] = nationality;

  return axios.get(`${config.API_URL}/api/v0/payments/nationality_based_payment`, {
    params,
  });
};

export const getIsAccDetailsUpdated = (paymentData: any, localPaymentData: any) => {
  if (paymentData?.inventory_id && localPaymentData?.inventory_id)
    return localPaymentData?.inventory_id !== paymentData?.inventory_id;
  return false;
};
